<form class="modal px-4 pb-4 pt-2 flex flex-col" (ngSubmit)="submitEmails()">
	<h3 class="mb-8">Invite colleagues</h3>
	<app-pill-input
		class="mb-8 w-500"
		[formControl]="emails"
		placeholder="Type or paste emails, separated by commas"
		[validatorFn]="validatorFn"
	></app-pill-input>
	<div class="flex justify-between">
		<app-button btn="secondary" (onClick)="close()">Close</app-button>
		<app-button
			btn="primary"
			type="submit"
			[disabled]="!emails.value.length || !emails.valid"
			>Send invite</app-button
		>
	</div>
</form>
